import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { filterEkgComments } from '../../../utilities/ekgImport.util'
import { TimelineConstants } from '../../timeline/store/timeline.constants'
import { IVitalItem } from '../../timeline/store/timeline.types'
import { IEventVitals } from '../store/ekgImport.types'

export const createTimelineItem = (eventVitals: IEventVitals, isPTA: boolean): IVitalItem => {
  const {
    date,
    time,
    dateTime,
    systolicBP,
    diastolicBP,
    heartRate,
    respirationRate,
    spo2,
    comments,
    clientEventId,
    vsAction,
    key,
  } = eventVitals
  const vitalItem: IVitalItem = {
    key: key,
    itemType: 'Vitals',
    grid: true,
    labelHeader: time,
    labelHeaderFlag: isPTA ? 'PTA' : '',
    paragraph: filterEkgComments(comments),
    clientCorrelationId: `patient.patientVitals_${eventVitals.key}`, // EKG imported vital should always create vitalGroup as isEkgImport is 1
    rowActionType: TimelineConstants.SET_VITAL_ITEM,
    defaultHref: TabConstants.VITALS_TAB,
    date: new Date(dateTime || 0),
    ...(clientEventId && { clientEventId: clientEventId.toString() }),
    ...(vsAction && { vsAction: vsAction }),
    isEkgImport: 1,
    subHeader: date,
    event: 'Vitals',
    keyValues: [
      { key: 'HR', value: heartRate || '', columnSize: '1' },
      { key: 'BP', value: `${systolicBP || ''}/${diastolicBP || ''}`, columnSize: '1' },
      { key: 'RR', value: respirationRate || '', columnSize: '1' },
      { key: 'SpO2', value: spo2 || '', columnSize: '1' },
    ],
  }

  return vitalItem
}
